<template>
  <div class="content-item">
    <h2 class="heading">
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2" style="width: 100px">
        <circle :class="[isAnimated && 'circle']" class="path" fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1" />
        <polyline :class="[isAnimated && 'check']" class="path" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 " />
      </svg>
      <p>Thank You!</p>
    </h2>
    <p class="text">
      We have received your card order. You will hear back from a designer in the next 2-3 business days. If you have ordered on a Friday or over the weekend please expect to hear from the designer by
      Wednesday or Thursday.
    </p>
  </div>
</template>
<script>
export default {
  name: 'Step16',

  data: () => ({
    isAnimated: false,
  }),
  methods: {
    doAnimated() {
      setTimeout(() => {
        this.isAnimated = true;
      }, 400);
    },
  },
};
</script>
<style lang="scss" scoped>
svg {
  width: 100px;
  display: block;
  margin: 40px auto 0;
}

.path {
  stroke-dasharray: 1000;
  stroke-dashoffset: 0;
  &.circle {
    animation: dash 0.9s ease-in-out;
  }
  &.line {
    stroke-dashoffset: 1000;
    animation: dash 0.9s 0.35s ease-in-out forwards;
  }
  &.check {
    stroke-dashoffset: -100;
    animation: dash-check 0.9s 0.35s ease-in-out forwards;
  }
}

p {
  text-align: center;
  margin: 20px 0 60px;
  font-size: 1.25em;
  &.success {
    color: #73af55;
  }
  &.error {
    color: #d06079;
  }
}

@keyframes dash {
  0% {
    stroke-dashoffset: 1000;
  }
  100% {
    stroke-dashoffset: 0;
  }
}

@keyframes dash-check {
  0% {
    stroke-dashoffset: -100;
  }
  100% {
    stroke-dashoffset: 900;
  }
}
</style>
